import { render } from "./addNewReferee.vue?vue&type=template&id=1be063af&ts=true"
import script from "./addNewReferee.vue?vue&type=script&lang=ts"
export * from "./addNewReferee.vue?vue&type=script&lang=ts"

import "./addNewReferee.vue?vue&type=style&index=0&id=1be063af&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__